// extracted by mini-css-extract-plugin
module.exports = {"root":"_ce4a0fc","mark":"_8ec11d0","markLabel":"_2ceb5ec"};